import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';

export const BopEconomicsSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const data = report.bopEconomics;
  const hasData = typeof data === 'string' && data.trim().length > 0;
  return (
    <SectionShell label={label} hasData={hasData}>
      {hasData && <p>{data}</p>}
    </SectionShell>
  );
};
